import { Form as FormikForm } from 'formik';
import styled from 'styled-components';

interface FormProps {
  isEdition?: boolean;
}

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1300px;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${({ theme }) => theme.group.whiteGrey};
    height: 100%;
    max-width: none;
  }
`;

export const Scaffold = styled.section`
  background-color: ${({ theme }) => theme.group.white};

  @media ${({ theme }) => theme.device.desktop} {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  @media ${({ theme }) => theme.device.mobile} {
    height: 100%;
    max-width: none;
  }
`;

export const Form = styled(FormikForm)<FormProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ isEdition }) => isEdition && '100px'};
`;

export const Fields = styled.div`
  flex: 1;
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: solid 1px ${({ theme }) => theme.group.division};
`;
